var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-app", [
    _c(
      "div",
      { attrs: { id: "app" } },
      [
        _c("navigation"),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { id: "main-body" } },
          [
            _c(
              "transition",
              {
                attrs: {
                  name: _vm.transitionName,
                  mode: _vm.transitionMode,
                  "enter-active-class": _vm.transitionEnterActiveClass
                },
                on: {
                  beforeLeave: _vm.beforeLeave,
                  enter: _vm.enter,
                  afterEnter: _vm.afterEnter
                }
              },
              [_c("router-view", { staticClass: "pt-6" })],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("Notification"),
        _vm._v(" "),
        _c("WernerFooter")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 